var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary admin-filter__reset",on:{"click":_vm.resetFilter}},[_vm._v(" Сбросить фильтр ")])
}
var staticRenderFns = []

export { render, staticRenderFns }